import * as React from 'react';
import * as Actions from './Actions';
import notify from '../../../shared/feedback/notifications';
import { connect } from 'react-redux';
import { Panel, Button, Checkbox, InputGroup, FormControl, Row } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import { handleError } from '../../../shared/ErrorCatching';

interface IActions {
    move: (orderId: number, orderCollection: string) => any;
}

interface IState {
    isActive: boolean;
    orderCollection: string;
}

class MoveOrderForm extends React.Component<any, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            isActive: false,
            orderCollection: ''
        };

        this.move = this.move.bind(this);
    }

    render() {
        return (
            <div className="move-suborder">
                {this.state.isActive && (
                    <Panel>
                        <InputGroup>
                            <FormControl
                                type="text"
                                name="orderCollection"
                                value={this.state.orderCollection}
                                onChange={(e: any) =>
                                    this.setState({
                                        orderCollection: e.target.value
                                    } as IState)
                                }
                            />
                            <InputGroup.Button>
                                <Button bsStyle="success" onClick={this.move}>
                                    {Translate('view-order/move/do')}
                                </Button>
                            </InputGroup.Button>
                        </InputGroup>
                    </Panel>
                )}
                <Checkbox
                    checked={this.state.isActive}
                    onChange={() =>
                        this.setState({
                            isActive: !this.state.isActive
                        } as IState)
                    }
                >
                    <span>{Translate('view-order/move/toggle')}</span>
                </Checkbox>
            </div>
        );
    }

    move(): void {
        this.props.actions
            .move(this.props.orderId, this.state.orderCollection)
            .then(() => {
                this.setState({ isActive: false } as IState);
                notify.success(Translate('view-order/move/success'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    notify.failure(Translate('view-order/move/failure'));
                })
            );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {};
}

function mapDispatchToProps(dispatch: any): { actions: IActions } {
    return {
        actions: {
            move: (orderId: number, orderCollection: string) =>
                dispatch(Actions.moveOrder(orderId, orderCollection))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MoveOrderForm);
